export const API_DATE_FORMAT = 'DD/MM/YYYY'
export const VUETIFY_DATE_FORMAT = 'YYYY-MM-DD'
export const HUMAN_READABLE_DATE_FORMAT = 'D [de] MMMM [de] YYYY'

export const ACTION_STATUS = {
  IDLE: 'IDLE',
  LOADING: 'LOADING',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
}

export const DEFAULT_CALIFICACION_EVALUACION_DESEMPEÑO = 1

export const DEFAULT_EQUIPMENT_DATE = '01/01/1900'
export const ESTATUS_EQUIPO_ACTIVO = 2

export const AULA_POR_DEFECTO_ID = 1

export const ESTATUS_CURSO_PERSONAL_PENDIENTE = 6

export const CORREO_PERSONAL_PENDIENTE = 'PENDIENTE@SSCTLAX.GOB.MX'
export const TELEFONO_PERSONAL_PENDIENTE = '0000000000'
